<template>
  <l-popup>
    <div class="window-group">
      <div class="window-place" @click="openPlaceByPlace(place)">
        <div
          class="window-place__cover"
          :style="{ backgroundImage: 'url(' + place.cover + ')' }"
        ></div>
        <div class="window-place-wrap">
          <p class="window-place__title">{{ place.title }}</p>
          <p class="window-place__text">{{ events.length }} ивента</p>
        </div>
      </div>
      <div class="window-list">
        <div class="window-event" @click.stop v-for="event in events" :key="event.id">
          <div
            class="window__image"
            :style="getBackground(event)"
            @click="openEvent(event)"
          >
            <div class="window-users">
              <div
                class="window-users__author"
                :style="{ backgroundImage: 'url(' + event.author.avatar + ')' }"
                :title="event.author.firstname + ' ' + event.author.lastname"
                @click="openUser(event.author)"
              ></div>
              <div
                class="window-users__elem"
                v-for="user in event.users.slice(0, 3)"
                :key="user.id"
                :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
                :title="user.firstname + ' ' + user.lastname"
                @click="openUser(user)"
              ></div>
              <div
                class="window-users__others"
                v-if="event.users && event.users.length > 2"
              >
                +{{ event.users.length - 3 }}
              </div>
            </div>
            <div class="window-category">
              <div class="categoryy" v-if="event.sports">
                <div
                  class="categoryy-item"
                  v-for="sport in event.sports"
                  :key="sport.id"
                  @click="setSport(sport)"
                  :class="sport.color"
                >
                  {{ sport.ru }}
                </div>
              </div>
            </div>

          </div>
          <div class="window-body">
            <h4 class="window__title" @click="openEvent(event)">
              {{ cutString(event.title, 70) }}
            </h4>

            <div class="window-info">
              <p class="window-info__place" @click="openPlace(event)">
                {{ getPlace(event) }}
              </p>
              <p class="window-info__date">{{ getDate(event.date_event) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </l-popup>
</template>
<script>
import { LPopup } from "vue2-leaflet";
export default {
  name: "m-popup",
  props: {
    place: {
      type: Object,
      required: true,
    },
    events: {
      type: Array,
      required: true,
    },
  },
  components: {
        "l-popup": LPopup
    },
  methods: {
    getBackground(event) {
      let cover = event.cover || event.place.cover || null;
      let bg_style = cover ? { backgroundImage: "url(" + cover + ")" } : {};
      return bg_style;
    },
    async openEvent(event) {
      this.$route.name === 'event' && ((this.event.id + "&" + this.event.hash) === this.$route.params.hash) 
        ? '' 
        : await this.$router.push({name: "event", params: { hash: event.id + '&' + event.hash }});
      this.$store.dispatch("changeMode", false);
    },
    openPlaceByPlace(place) {
      this.$router.push({ name: "place", params: { hash: place.id + '&' + place.hash } });
    },
    openPlace(event) {
      event.place
        ? this.$router.push({
            name: "place",
            params: { hash: event.place.id + '&' + event.place.hash },
          })
        : "";
    },
    openUser(user) {
      this.$router.push({ name: "user", params: { id: user.id } });
    },
    openDestination(event) {
      this.$store.dispatch("setDestinationId", event.id);
      this.$store.dispatch("setTransport", true);
    },
    setSport(sport) {
      sport.active = true;
      this.$store.dispatch("changeSports", sport);
    },
    getDate(val) {
      let date = this.$moment(val).locale("ru").calendar();
      return date;
    },
    getPlace(event) {
      return event.place
        ? this.cutString(event.place.title, 21)
        : this.cutString(event.latitude, 7) +
            ", " +
            this.cutString(event.longitude, 7);
    },
    cutString(val, length) {
      if (val) {
        val = val.toString();
        val = val.length > length ? val.slice(0, length).concat("...") : val;
      }
      return val;
    },
  }
};
</script>